import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  useTheme,
} from "@mui/material";
// import { io } from "socket.io-client";
import image1 from "../Assets/Gif/1.gif";
import image2 from "../Assets/Gif/2.gif";
import image3 from "../Assets/Gif/3.gif";
import image4 from "../Assets/Gif/4.gif";

const SERVER_IP = "http://192.168.0.102";
// const moduleServer = io(SERVER_IP + ":5401", { autoConnect: false });
// const code = `
//   const start = async function(){
//     this.utensil = 'np2';
//     await lidOpen(this.utensil);
//     await chimny(1);
//     await pourOil('olive',1,this.utensil);
//     await pourBowl(1,this.utensil);
//     dispensePowder(1,1);
//     await stirManually(this.utensil,1,2);
//     homePowder();
//     await pourPowderCup(this.utensil);
//     await pourPaste(this.utensil,1);
//     await pourWater(50,this.utensil);
//     await lidClose(this.utensil);
//     await chimny(0);
//     await releaseSteam(this.utensil);
//     await waitAndDanceFor(10);
//   };
//   start().catch(console.log);
// `;
const code = `
  const start = async function(){
    this.utensil = 'np2';
    await lidOpen(this.utensil);
    await chimny(1);
    await pourOil('olive',1,this.utensil);
    await pourBowl(1,this.utensil);
    await stirManually(this.utensil,1,2);
    homePowder();
    await pourPowderCup(this.utensil);
    await pourPaste(this.utensil,1);
    await pourWaterOnly(this.utensil);
    await lidClose(this.utensil);
    await chimny(0);
    await waitAndDanceFor(10);
  };
  start().catch(console.log);
`;

const CookingProcess = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(276); // 5 minutes in seconds
  const [isCookingComplete, setIsCookingComplete] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [image1, image2, image3];

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };

  // useEffect(() => {
  //   const socket = io(`${SERVER_IP}:5401`, { transports: ["websocket"] });

  //   socket.on("connect", () => {
  //     socket.emit("cook-now", code, (response) => {
  //       if (response === true) {
  //         setTimeout(() => navigate("/dashboard"), 10000);
  //       }
  //     });
  //   });

  //   socket.on("connect_error", (error) => {
  //     console.error("Connection error:", error);
  //   });

  //   return () => socket.disconnect();
  // }, [navigate]);

  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    const timerInterval = setInterval(() => {
      setTimeLeft((prev) => Math.max(prev - 1, 0));
    }, 1000);

    if (timeLeft === 0) {
      clearInterval(timerInterval);
      setIsCookingComplete(true);
    }

    return () => {
      clearInterval(imageInterval);
      clearInterval(timerInterval);
    };
  }, [timeLeft]);

  if (isCookingComplete) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        bgcolor={theme.palette.background.default}
        textAlign="center"
        p={3}
      >
        <Typography variant="h3" color="primary" gutterBottom>
          🎉 Cooking Complete! 🎉
        </Typography>
        <Box
          mt={3}
          sx={{
            width: 200,
            height: 200,
            background: `url(${image4})`,
            backgroundSize: "cover",
            borderRadius: "50%",
          }}
        />
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3 }}
          onClick={() => navigate("/dashboard")}
        >
          Back to Recipes
        </Button>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection={{ xs: "column", md: "row" }}
      alignItems="center"
      justifyContent="space-between"
      height="100vh"
      bgcolor={theme.palette.background.default}
      p={2}
    >
      {/* Left Side - GIF */}
      <Box
        width={{ xs: "100%", md: "50%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <img
          src={images[currentImageIndex]}
          alt={`Cooking Step ${currentImageIndex + 1}`}
          style={{
            width: "100%",
            maxHeight: "40vh",
            borderRadius: "10px",
            objectFit: "contain",
            transition: "opacity 0.5s ease-in-out",
          }}
        />
      </Box>

      {/* Right Side - Timer and Details */}
      <Box
        width={{ xs: "100%", md: "50%" }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        p={3}
      >
        <Typography variant="h4" gutterBottom>
          Cooking Demonstration
        </Typography>
        <Typography variant="h5" color="primary" gutterBottom>
          Demo
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Cooking Time Left:
        </Typography>
        <Box position="relative" display="inline-flex" my={2}>
          <CircularProgress
            variant="determinate"
            value={(timeLeft / 300) * 100}
            size={100}
            thickness={4}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h6" component="div" color="textPrimary">
              {formatTime(timeLeft)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CookingProcess;
